import React from "react";
import { useTranslation } from "src/context/Translations/context";
import { RCCGrid, RCCInput, RCCTextArea } from "react-common-components";
import LovAnalysisModels from "src/components/Lov/AnalysisModels";
import DateTimePicker from "src/components/DateTimePicker";
import { IComponentAnalysis } from "./interface";

const FormStandardsFields: React.FC<IComponentAnalysis> = ({
	isDisabled,
	isAdd,
	data,
	register,
	control,
	error,
	watch,
	onChangeAnalysisModel
}) => {
	const { translate } = useTranslation();

	const onChangeLov = (e: any) => {
		const matba006 = watch("matba006");
		onChangeAnalysisModel(e, matba006);
	};

	return (
		<>
			<RCCGrid styleInline="display: none">
				<RCCInput 
					register={register}
					name="maa001Id"
					label=""
					defaultValue={data.maa001Id || 0}
					readOnly
				/>
			</RCCGrid>
			<RCCGrid
				container 
				item
				xs={12}
				sm={10}
				styleInline={isAdd ? "display: block" : "display: none !important"}
			>
				<LovAnalysisModels 
					control={control}
					name="maa001Maa001Id"
					label={translate("Modelo")}
					defaultValue={data.maa001Maa001Id}
					onChangeCapture={onChangeLov}
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid 
				container 
				item
				xs={12}
				sm={10}
			>
				<RCCInput 
					name="maa001Titulo"
					register={register}
					label={translate("Título")}
					defaultValue={data.maa001Titulo}
					error={error.maa001Titulo}
					maxLength={60}
					required
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid 
				container 
				item
				xs={12}
				sm={10}
			>	
				<RCCTextArea 
					register={register}
					label={translate("Descrição")}
					name="maa001Descricao"
					error={error.maa001Descricao}
					defaultValue={data.maa001Descricao}
					maxLength={4000}
					required
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid
				container 
				item
				xs={12}
				sm={10}
			>
				<DateTimePicker 
					type="datePicker"
					label={translate("Data")}
					name="maa001Data"
					defaultValue={new Date()}	
					control={control}
					error={error.maa001Data}
					styleInline="margin: 5px 0;"
					required
					props={{
						datePicker: {
							disabled: isDisabled
						}
					}}
				/>
			</RCCGrid>
		</>
	);
};

export default FormStandardsFields;
